import React,{useEffect} from 'react';
import {BrowserRouter as Router,Routes,Route} from 'react-router-dom';
import Header from './components/Header';
import HomePage from './components/HomePage';
import ProblemSolving from './components/ProblemSolving';
import FreeLandingPageOffer from './components/FreeLandingPageOffer';
import FreeLandingPageBR from './components/FreeLandingPageBR';
import FreeLandingPageRU from './components/FreeLandingPageRU';
import FreeLandingPageGlobal from './components/FreeLandingPageGlobal';
import PaigePage from './components/PaigePage';
import ContactPage from './components/ContactPage';
import ProjectsPage from './components/ProjectsPage';
import MarketingTrainingPage from './components/MarketingTrainingPage';
import CoursesPage from './components/CoursesPage';
import FullStackCoursePage from './components/FullStackCoursePage';
import FullStackCoursePageGS from './components/FullStackCoursePageGS';
import FullStackCoursePageJS from './components/FullStackCoursePageJS';
import BuildAppsWithAIPage from './components/BuildAppsWithAIPage';
// New price variant components
import FullStackCoursePageControl4999 from './components/FullStackCoursePageControl4999';
import FullStackCoursePageControl6999 from './components/FullStackCoursePageControl6999';
import FullStackCoursePageControl9999 from './components/FullStackCoursePageControl9999';
import FullStackCoursePageControl14999 from './components/FullStackCoursePageControl14999';
import FullStackCoursePageJS4999 from './components/FullStackCoursePageJS4999';
import FullStackCoursePageJS6999 from './components/FullStackCoursePageJS6999';
import FullStackCoursePageJS9999 from './components/FullStackCoursePageJS9999';
import FullStackCoursePageJS14999 from './components/FullStackCoursePageJS14999';
import FullStackCoursePageGS4999 from './components/FullStackCoursePageGS4999';
import FullStackCoursePageGS6999 from './components/FullStackCoursePageGS6999';
import FullStackCoursePageGS9999 from './components/FullStackCoursePageGS9999';
import FullStackCoursePageGS14999 from './components/FullStackCoursePageGS14999';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsAndConditions from './components/TermsAndConditions';
import RefundPolicy from './components/RefundPolicy';
import Disclaimer from './components/Disclaimer';
import CookiePolicy from './components/CookiePolicy';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
// Thank You Pages
import ProblemSolvingThankYou from './components/ProblemSolvingThankYou';
import FreeLandingPageThankYou from './components/FreeLandingPageThankYou';
import FreeLandingPageBRThankYou from './components/FreeLandingPageBRThankYou';
import FreeLandingPageRUThankYou from './components/FreeLandingPageRUThankYou';
import FreeLandingPageGlobalThankYou from './components/FreeLandingPageGlobalThankYou';
import MarketingTrainingThankYou from './components/MarketingTrainingThankYou';
import ContactThankYou from './components/ContactThankYou';
import FullStackCourseThankYou from './components/FullStackCourseThankYou';
import {initializeTracking} from './utils/analytics';
import './App.css';

function App() {
useEffect(()=> {
// Initialize tracking when app loads
initializeTracking();
},[]);

return (
<Router>
<ScrollToTop />
<div className="min-h-screen bg-white flex flex-col">
<Routes>
{/* Thank You Pages - No header/footer for clean experience */}
<Route path="/problem-solving-thank-you" element={<ProblemSolvingThankYou />} />
<Route path="/free-landing-page-thank-you" element={<FreeLandingPageThankYou />} />
<Route path="/free-landing-page-br-thank-you" element={<FreeLandingPageBRThankYou />} />
<Route path="/free-landing-page-ru-thank-you" element={<FreeLandingPageRUThankYou />} />
<Route path="/free-landing-page-global-thank-you" element={<FreeLandingPageGlobalThankYou />} />
<Route path="/marketing-training-thank-you" element={<MarketingTrainingThankYou />} />
<Route path="/contact-thank-you" element={<ContactThankYou />} />
<Route path="/learn-full-stack-marathi-thank-you" element={<FullStackCourseThankYou />} />

{/* AI App Builder Page */}
<Route path="/build-apps-with-ai-free-module-access" element={<div className="flex-grow flex flex-col"><BuildAppsWithAIPage /><Footer /></div>} />

{/* Original Course Pages */}
<Route path="/learn-full-stack-marathi" element={<div className="flex-grow flex flex-col"><FullStackCoursePage /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-gs" element={<div className="flex-grow flex flex-col"><FullStackCoursePageGS /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-js" element={<div className="flex-grow flex flex-col"><FullStackCoursePageJS /><Footer /></div>} />

{/* Control Price Variants */}
<Route path="/learn-full-stack-marathi-control-4999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageControl4999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-control-6999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageControl6999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-control-9999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageControl9999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-control-14999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageControl14999 /><Footer /></div>} />

{/* JS Price Variants */}
<Route path="/learn-full-stack-marathi-js-4999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageJS4999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-js-6999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageJS6999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-js-9999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageJS9999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-js-14999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageJS14999 /><Footer /></div>} />

{/* GS Price Variants */}
<Route path="/learn-full-stack-marathi-gs-4999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageGS4999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-gs-6999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageGS6999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-gs-9999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageGS9999 /><Footer /></div>} />
<Route path="/learn-full-stack-marathi-gs-14999" element={<div className="flex-grow flex flex-col"><FullStackCoursePageGS14999 /><Footer /></div>} />

{/* Conversion-focused pages with only Footer */}
<Route path="/problem-solving" element={<div className="flex-grow flex flex-col"><ProblemSolving /><Footer /></div>} />
<Route path="/free-landing-page" element={<div className="flex-grow flex flex-col"><FreeLandingPageOffer /><Footer /></div>} />
<Route path="/free-landing-page-br" element={<div className="flex-grow flex flex-col"><FreeLandingPageBR /><Footer /></div>} />
<Route path="/free-landing-page-ru" element={<div className="flex-grow flex flex-col"><FreeLandingPageRU /><Footer /></div>} />
<Route path="/free-landing-page-global" element={<div className="flex-grow flex flex-col"><FreeLandingPageGlobal /><Footer /></div>} />
<Route path="/marketing-training" element={<div className="flex-grow flex flex-col"><MarketingTrainingPage /><Footer /></div>} />

{/* Legal pages with header and footer */}
<Route path="/privacy-policy" element={<><Header /><PrivacyPolicy /><Footer /></>} />
<Route path="/terms-and-conditions" element={<><Header /><TermsAndConditions /><Footer /></>} />
<Route path="/refund-policy" element={<><Header /><RefundPolicy /><Footer /></>} />
<Route path="/disclaimer" element={<><Header /><Disclaimer /><Footer /></>} />
<Route path="/cookie-policy" element={<><Header /><CookiePolicy /><Footer /></>} />

{/* Regular pages with header/footer */}
<Route path="/" element={<><Header /><HomePage /><Footer /></>} />
<Route path="/paige" element={<><Header /><PaigePage /><Footer /></>} />
<Route path="/about" element={<><Header /><PaigePage /><Footer /></>} />
<Route path="/contact" element={<><Header /><ContactPage /><Footer /></>} />
<Route path="/projects" element={<><Header /><ProjectsPage /><Footer /></>} />
<Route path="/courses" element={<><Header /><CoursesPage /><Footer /></>} />
</Routes>
</div>
</Router>
);
}

export default App;